import axios from "axios";

export const createTopicArea = async (username, topicAreaVOToCreate) => {
    try {
        const {data} = await axios.post("/api/topicArea/create", {username, topicAreaVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllTopicAreas = async (username) => {
    try {
        const {data} = await axios.get("/api/topicArea/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateTopicArea = async (username, topicAreaVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/topicArea/update", {username, topicAreaVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteTopicArea = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/topicArea/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

